import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Dashboard from './pages/Dashboard'
import InboxPage from './pages/inbox/InboxPage'
import Login from './pages/Login'
import Settings from './pages/Settings'
import Sync from './pages/Sync'
import CampaignList from './pages/campaigns/CampaignList'
import CampaignDetail from './pages/campaigns/CampaignDetail'
import KeywordList from './pages/keywords/KeywordList'
import TargetsList from './pages/asin-targeting/TargetsList'
import PortfolioTree from './pages/portfolios/PortfolioTree'
import Promotions from './pages/promotions/Promotions'
import ExperimentsDashboard from './pages/experiments/ExperimentsDashboard'
import ExperimentDetail from './pages/experiments/ExperimentDetail'
import LearningEvolution from './pages/learning/LearningEvolution'
import BulkImport from './pages/BulkImport'
import OperatorReconcile from './pages/OperatorReconcile'
import HarvestWorkspace from './pages/harvest/HarvestWorkspace'
import RulesView from './pages/rules/RulesView'
import NamingGenerator from './pages/naming/NamingGenerator'
import WaveEconomics from './pages/WaveEconomics'
import FamilyEconomics from './pages/FamilyEconomics'
import WikiPage from './pages/wiki/WikiPage'
import NotFound from './pages/NotFound'

const LaunchReviewPage = lazy(() => import('./pages/launch-review/LaunchReviewPage'))
const LaunchCasesPage = lazy(() => import('./pages/launch-cases/LaunchCasesPage'))

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Oeffentliche Route */}
        <Route path="/login" element={<Login />} />

        {/* Geschuetzte Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route index element={<InboxPage />} />
            <Route path="/performance" element={<Dashboard />} />
            <Route path="/campaigns" element={<CampaignList />} />
            <Route path="/launch-review" element={<Suspense fallback={<p role="status">Paketprüfung laden …</p>}><LaunchReviewPage /></Suspense>} />
            <Route path="/launch-cases" element={<Suspense fallback={<p role="status">Launch-Fälle laden …</p>}><LaunchCasesPage /></Suspense>} />
            <Route path="/campaigns/:id" element={<CampaignDetail />} />
            <Route path="/portfolios" element={<PortfolioTree />} />
            <Route path="/keywords" element={<KeywordList />} />
            <Route path="/asin-targeting" element={<TargetsList />} />
            <Route path="/promotions" element={<Promotions />} />
            <Route path="/experiments" element={<ExperimentsDashboard />} />
            <Route path="/experiments/:id" element={<ExperimentDetail />} />
            <Route path="/learning" element={<LearningEvolution />} />
            <Route path="/bulk-import" element={<BulkImport />} />
            <Route path="/reconcile" element={<OperatorReconcile />} />
            <Route path="/sync" element={<Sync />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/harvest" element={<HarvestWorkspace />} />
            <Route path="/rules" element={<RulesView />} />
            <Route path="/naming" element={<NamingGenerator />} />
            {/* Wellen-Economics (Shadow-v1): reine Beobachtung, mit und ohne Wellen-Nummer erreichbar. */}
            <Route path="/wave-economics" element={<WaveEconomics />} />
            <Route path="/wave-economics/:id" element={<WaveEconomics />} />
            <Route path="/family-economics" element={<FamilyEconomics />} />
            <Route path="/wiki" element={<WikiPage />} />
            <Route path="/wiki/:slug" element={<WikiPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
